const patientSummary = {
    patientSummary:'Patient Summary',
    default:'Default',
    timeline:'Timeline',
    carePlan:'Care Plan',
    patientVitals:'Patient Vitals',
    currentSession:'Current Session',
    stopTimer:'Submit',
    pauseTimer:'Pause Timer',
    resumeTimer:'Resume Timer',
    startTimer:'Start Timer',
    notifications:'Notifications',
    visits:'Visits',
    notes:'Notes',
    appointments:'Appointments',
    documents:'Documents',

    timeTrackerModal:{
        patientReviewTime:"Patient Review Time",
        billingCode:'Billing Code',
        videoConsultTime:'Video Consult Time',
        videoBillingCode:'Video Billing Code'
    },

    bloodPressureDetails:{
        bloodPressureDetail:'Blood Pressure Detail',
        bloodPressure:'Blood Pressure',
    },

    vitalSummary:{
        BP:'BP',
        dateTime:'Date & Time',
        systolic:'Systolic',
        diastoli:'Diastoli',
        SpO2:'SpO2',
        value:'Value',
        glucose:'Glucose',
        weight:'Weight'


    }

  }


export default patientSummary